export function smoothScrollToAnchor(_sel) {
	_sel.addEventListener('click', function(e) {
		e.preventDefault();

		if (document.querySelector('.site-navigation__navicon--active') && document.body.classList.contains('site-navigation--open')) {
			document.querySelector('.site-navigation__navicon').click();
		}

		if (e.target.parentNode.parentNode && e.target.parentNode.parentNode.classList.contains('site-navigation__sub-menu')) {
			e.target.parentNode.parentNode.classList.remove('site-navigation__sub-menu--active');
		}

		if (e.target.parentNode.parentNode.parentNode && e.target.parentNode.parentNode.classList.contains('site-navigation__menu-item')) {
			e.target.parentNode.parentNode.parentNode.querySelector('a').classList.remove('site-navigation__menu-item--active');
		}

		if (e.target.href.includes('#') && document.getElementById(e.target.href.split('#')[ 1 ])) {
			document.getElementById(e.target.href.split('#')[ 1 ]).scrollIntoView({ behavior: 'smooth' });
		} else {
			window.location.href = e.target.href;
		}
	});
}
